import React, {
    Suspense
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../globals";
import { setShowModal } from "../../../../redux/reducers/paymentsReducer";
import Constants, { FINANCES_MODALS, REPORT_TYPES } from "../../../../constants";
import CancelInvoiceModalComponent from "../../../../components/modals/cancelInvoice/cancelInvoice";
import GenerateInvoiceModalComponent from "../../../../components/modals/generateInvoice/generateInvoice";
import InvoiceDetailModalComponent from "../../../../components/modals/invoiceDetails/invoiceDetails";
import CancelPaymentModalComponent from "../../../../components/modals/payments/cancel/cancelPayment";
import EmitPaymentModalComponent from "../../../../components/modals/payments/create/emitPayment";
import PaymentDetailModalComponent from "../../../../components/modals/payments/detail/paymentDetails";
import FiltrosRapidos from "../../../../components/filtrosRapidos/filtrosRapidos";
import CommonTable from "../../../../components/commonTable";
import PaginationComponent from "../../../../components/pagination/pagination";
import Card from "../../../../components/card";
import SearchInputComponent from "../../../../components/searchInput/searchInput";
import ReportButtonComponent from "../../../../components/buttons/reportButton/reportButton";
import PaymentUpdateModalComponent from "../../../../components/modals/payments/update/updatePayment";
//styles
import "./style.scss";
import "../finanzasLayout.css";

import AsideModalComponent from "../../../../components/modals/asideModal";
import { PERMISSIONS_CODES } from "../../../../constants";
import RegisterPaymentModal from "../../../../components/modals/payments/register/registerPaymentModal";
import RS from "../../../../components/modals/payments/register/strings";
import DiscountRequestsModal from "../../../../components/modals/payments/register/discountRequestsModal";
import ReceiptDetailModal from "../../../../components/modals/payments/multi/receiptDetailModal";

const PaymentView = (props: any) => {
    const {
        paymentProps,
        paginationProps,
        searchProps,
        invoiceDetailProps,
        paymentDetailProps,
        emitPaymentProps,
        cancelPaymentProps,
        generateInvoiceProps,
        cancelInvoiceProps,
        paymentUpdateProps,
        multiProps,
        receiptProps
    } = props

    const dispatch = useDispatch<AppDispatch>();
    const permisos: any[] = useSelector((state: RootState) => state.rootReducer.sessionState.permissions) || [];
    const showModal: boolean = useSelector((state: RootState) => state.rootReducer.payments.showModal);
    const modalContent: any = useSelector((state: RootState) => state.rootReducer.payments.modalContent);
    const student: any = useSelector((state: RootState) => state.rootReducer.payments.studentData);
    const payment: any = useSelector((state: RootState) => state.rootReducer.payments.selectedPayment);
    const invoice: any = useSelector((state: RootState) => state.rootReducer.payments.selectedInvoice);
    const itemsInInvoice: any = useSelector((state: RootState) => state.rootReducer.payments.invoiceItems);
    const totalToPaid: any = useSelector((state: RootState) => state.rootReducer.payments.totalToPaid);

    /*
        Conteo en el vocabulario de Pagos y Movimientos: un pago multipersona es UN pago
        aunque ocupe varias filas. Solo cuando hay alguno se aclaran los movimientos.
    */
    const filas: any[] = paymentProps.payments || [];
    const conteo = (() => {
        const movimientos = filas.filter((r: any) => !r.isReceiptRow).length;
        const pagos = filas.filter((r: any) => r.isReceiptRow || !r.isMulti).length;
        return { pagos, sufijo: movimientos > pagos ? ` · ${movimientos} movimientos` : "" };
    })();
    const renderModalContent = (children: number) => {
        switch (children) {
            case FINANCES_MODALS.INVOICE:
                return (
                    <InvoiceDetailModalComponent
                        student={student}
                        invoice={invoice}
                        closeModal={invoiceDetailProps.closeModal}
                        showPaymentDetail={invoiceDetailProps.showPaymentDetail}
                        showCreditDetail={invoiceDetailProps.showCreditDetail}
                        cancelInvoice={invoiceDetailProps.cancelInvoice}
                        proccessPayment={invoiceDetailProps.proccessPayment}
                    />
                );
            case FINANCES_MODALS.GENERATE_INVOICE:
                return (
                    <GenerateInvoiceModalComponent
                        onSuccess={generateInvoiceProps.onSuccess}
                        closeModal={generateInvoiceProps.closeModal}
                    />
                );
            case FINANCES_MODALS.CANCEL_INVOICE:
                return (
                    <CancelInvoiceModalComponent
                        student={student}
                        invoice={invoice}
                        closeModal={cancelInvoiceProps.closeModal}
                        onSuccess={cancelInvoiceProps.onSuccess}
                    />
                );
            case FINANCES_MODALS.PAYMENT_DETAIL:
                return (
                    <PaymentDetailModalComponent
                        student={student}
                        payment={payment}
                        closeModal={paymentDetailProps.closeModal}
                        handleCancelPayment={paymentDetailProps.handleCancelPayment}
                        showPaymentUpdate={paymentDetailProps.showPaymentUpdate}
                    />
                );
            case FINANCES_MODALS.EMIT_PAYMENT:
                return (
                    <EmitPaymentModalComponent
                        student={student}
                        invoice={invoice}
                        itemsInInvoice={itemsInInvoice}
                        totalToPaid={totalToPaid}
                        isPartialPayment={emitPaymentProps.isPartialPayment}
                        isNewInvoice={emitPaymentProps.isNewInvoice}
                        closeModal={emitPaymentProps.closeModal}
                        cancelEmitPayment={emitPaymentProps.cancelEmitPayment}
                        onSuccess={emitPaymentProps.onSuccess}
                        showApplyCreditModal={emitPaymentProps.showApplyCreditModal}
                    />
                );
            case FINANCES_MODALS.CANCEL_PAYMENT:
                return (
                    <CancelPaymentModalComponent
                        student={student}
                        payment={payment}
                        closeModal={cancelPaymentProps.closeModal}
                        onSuccess={cancelPaymentProps.onSuccess}
                    />
                );
            case FINANCES_MODALS.UPDATE_PAYMENT:
                return (
                    <PaymentUpdateModalComponent
                        student={student}
                        payment={payment}
                        closeModal={paymentUpdateProps.closeModal}
                        onSuccess={paymentUpdateProps.onSuccess}
                    />
                );
            default:
                dispatch(setShowModal(false));
                return null;
        }
    }

    return (
        <div className={`transition-width${showModal ? " waFinanzasConPanel" : ""}`}>

            <div className="row"
                style={{
                    paddingLeft: "30px",
                    paddingRight: "30px"
                }}>
                {/* Cabecera en flex (sin col-lg-*): título + Registrar Pago, buscador que se encoge y los botones; a 1280 px no se sale. */}
                <div
                    className="col-lg-12 waCabeceraModulo waCabeceraFinanzas"
                    style={{
                        padding: "30px",
                        display: "flex",
                        gap: "24px",
                        alignItems: "center",
                        flexWrap: "wrap"
                    }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            flex: "0 0 auto"
                        }}>
                        <h2>{Constants.Common.payments}</h2>
                        {/* Registrar pago (Cobros unificado): el modal único, en blanco, junto al título. */}
                        {multiProps && permisos.includes(PERMISSIONS_CODES.PAYMENT_PERMISSIONS.CREATE) ? (
                            <button type="button" className="btn btn-primary rounded-pill" style={{ whiteSpace: "nowrap", marginLeft: "14px", alignSelf: "center" }} onClick={multiProps.open}>{RS.newPayment}</button>
                        ) : ""}
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            flex: "1 1 260px",
                            minWidth: 0,
                            maxWidth: "420px"
                        }}>
                        <SearchInputComponent
                            search={searchProps.search}
                            onChangeSearch={searchProps.onChangeSearch}
                            onClickSearch={searchProps.onClickSearch}
                            onClearSearch={searchProps.onClearSearch}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "6px",
                            flex: "0 0 auto"
                        }}>
                        <ReportButtonComponent
                            onClick={() => paymentProps.reportFunction()}
                            reportType={REPORT_TYPES.XLSX}
                            label="Reporte (.xlsx)"
                        />
                        {multiProps ? <button type="button" className="btn btn-outline-primary rounded-pill" style={{ whiteSpace: "nowrap" }} onClick={multiProps.discounts.show}>Descuentos Especiales</button> : ""}
                    </div>
                </div>
                {multiProps?.avisoEnlace?.texto ? (
                    <div className="alert alert-warning" role="alert" style={{ fontSize: 15, cursor: "pointer", width: "100%" }} onClick={multiProps.avisoEnlace.cerrar}>{multiProps.avisoEnlace.texto}</div>
                ) : ""}
                <div style={{
                    padding: 0,
                    width: "100%"
                }}>
                    <Card>
                        <div
                            className="paymentTableContainer col-lg-12"
                            style={{
                                padding: "10px 10px 0px 10px",
                            }}>
                            {/*
                                Filtros rapidos: lo que de verdad se consulta, a un
                                toque. Abre con "Hoy" puesto. La caja de busqueda ya
                                vive arriba, por eso sinBuscador.

                                Sin boton de reinicio a proposito: se ve cual chip
                                esta encendido y eso basta. (Esteban, 2026-09-21)
                            */}
                            <FiltrosRapidos
                                chips={paymentProps.chips}
                                valores={paymentProps.rapidos}
                                onCambio={paymentProps.onRapidos}
                                sinBuscador
                                busqueda=""
                                onBusqueda={() => {}}
                                onBuscar={() => {}}
                                onLimpiar={() => {}}
                                idleLocked={false}
                                cuenta={conteo.pagos}
                                nombreUno={"pago" + conteo.sufijo}
                                nombreVarios={"pagos" + conteo.sufijo}
                            />
                            <CommonTable
                                tarjetasEnTelefono
                                columns={paymentProps.columns}
                                data={paymentProps.payments}
                                filters={paymentProps.filters}
                                onFilterChange={paymentProps.onFilterChange}
                                onClearFilters={paymentProps.onClearFilters}
                            >
                            </CommonTable>
                        </div>
                    </Card>
                    <div className="waPaginadorFinanzas"
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            background: "var(--wa-superficie)"
                        }}>
                        <PaginationComponent
                            pages={paginationProps.pages}
                            onPageSizeChange={paginationProps.handlePageSizeChange}
                            pageSizeVisible={true}
                            pageSizes={paginationProps.pagesSize}
                            itemCount={paginationProps.itemCount}
                        />
                    </div>
                </div>
            </div>
            <Suspense fallback={<div>Loading...</div>}>
                <AsideModalComponent
                    showModal={showModal}
                    location="right"
                    style={{ width: "648px" }}>
                    {renderModalContent(modalContent)}
                </AsideModalComponent>
            </Suspense>
            {multiProps && multiProps.discounts.open ? (
                <DiscountRequestsModal campusId={multiProps.campusId} currencySymbol={multiProps.currencySymbol} focusId={multiProps.discounts.focusId} onClose={multiProps.discounts.close} />
            ) : ""}
            {multiProps && multiProps.show ? (
                <Suspense fallback={<React.Fragment />}>
                    <RegisterPaymentModal campusId={multiProps.campusId} currencySymbol={multiProps.currencySymbol}
                        onClose={multiProps.close} onSuccess={multiProps.onSuccess} />
                </Suspense>
            ) : ""}
            {receiptProps && receiptProps.id ? (
                <Suspense fallback={<React.Fragment />}>
                    <ReceiptDetailModal campusId={receiptProps.campusId} receiptId={receiptProps.id} onClose={receiptProps.close}
                        onCancelled={receiptProps.onCancelled} onOpenMovement={receiptProps.onOpenMovement} />
                </Suspense>
            ) : ""}
        </div>
    )
}

export default PaymentView;